"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDuration = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const duration_1 = __importDefault(require("dayjs/plugin/duration"));
dayjs_1.default.extend(duration_1.default);
const formatDuration = period => {
  const parts = [];
  const dur = dayjs_1.default.duration(period, 'seconds');
  if (!dur || dur.toISOString() === 'P0D') {
    return '0 seconds';
  }
  if (dur.years() >= 1) {
    const years = Math.floor(dur.years());
    parts.push(years + ' ' + (years > 1 ? 'years' : 'year'));
  }
  if (dur.months() >= 1) {
    const months = Math.floor(dur.months());
    parts.push(months + ' ' + (months > 1 ? 'months' : 'month'));
  }
  if (dur.days() >= 1) {
    const days = Math.floor(dur.days());
    parts.push(days + ' ' + (days > 1 ? 'days' : 'day'));
  }
  if (dur.hours() >= 1) {
    const hours = Math.floor(dur.hours());
    parts.push(hours + ' ' + (hours > 1 ? 'hours' : 'hour'));
  }
  if (dur.minutes() >= 1) {
    const minutes = Math.floor(dur.minutes());
    parts.push(minutes + ' ' + (minutes > 1 ? 'minutes' : 'minute'));
  }
  if (dur.seconds() >= 1) {
    const seconds = Math.floor(dur.seconds());
    parts.push(seconds + ' ' + (seconds > 1 ? 'seconds' : 'second'));
  }
  return parts.length > 0 ? parts.join(', ') : '0 seconds';
};
exports.formatDuration = formatDuration;
//# sourceMappingURL=format-duration.js.map